import { Component, Renderer2, ChangeDetectorRef,NgZone } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { professionalLocatorService } from "../../services/professional-locator.service";
import { environment } from "../../../../environments/environment";
import { HttpClient } from '@angular/common/http';

declare const grecaptcha:any;

@Component({
  selector: "app-professional-locator",
  templateUrl: "./locator.component.html",
  styleUrls: ["./locator.component.css"],
})
export class LocatorComponent {
  title = "professionalLocator";
  tags: string[] = [];
  cards: any = [];
  currentPage = 1;
  itemsPerPage = 6;
  paginatedCards: any[] = [];
  totalPages: number = 1;
  isLoading = false;
  searchForm: FormGroup;
  submitted = false;
  errorMessage: any = null;
  professionalFilter: any = "";
  appliedRepChecked: boolean = false;
  distributorChecked: boolean = false;
  private clickListener: () => void;
  errorLink: any = null;
  noResultFound:any=null;
  mvspTip:boolean = false;
  mvpTip:boolean = false;
  captchaResponse: string | null = null;
  captchaVerified: boolean = false;
  cdr: any;

  constructor(
    private professionalLocator: professionalLocatorService,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    private zone:NgZone,
    private http:HttpClient

  ) {
    this.searchForm = this.formBuilder.group({
      searchField: ["", [Validators.required, this.isValidUSZip()]], // Validators for ZIP code
    });
    this.clickListener = this.renderer.listen("document", "click", (event) =>
      this.onDocumentClick(event)
    );
  }

  onDocumentClick(event: MouseEvent) {
    this.hideAllTooltips();
  }

  hideAllTooltips() {
    this.cards.forEach((card: any) => (card.showcardtooltip = false));
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    window['onCaptchaSuccess'] = this.onCaptchaSuccess.bind(this);
    this.loadInvocaScript();
    this.updatePaginatedCards();
    this.loadreCaptchaScript();
  }

  loadInvocaScript() {
    // Create a script element
    const script = this.renderer.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      (window.location.protocol === "https:" ? "https://" : "http://") +
      "solutions.invocacdn.com/js/invoca-latest.min.js";

    (window as any).InvocaTagId = "2415/1758133708";

    const head = document.getElementsByTagName("head")[0];
    this.renderer.appendChild(head, script);
  }

  get searchField() {
    return this.searchForm.get("searchField");
  }

  clearSearchField() {
    if (this.searchForm.get("searchField")) {
      this.searchForm.get("searchField").setValue("");
    }
    this.submitted = false;
    this.paginatedCards = [];
    this.errorMessage = null;
    this.errorLink = null;
    this.noResultFound = null;
  }


  clearErrorMessage(event:any){
    this.noResultFound = null;
    this.errorMessage = null;
    this.errorLink = null;
    this.paginatedCards = [];
  }

  updatePaginatedCards(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedCards = this.cards.slice(startIndex, endIndex); // Slice the cards array
    setTimeout(() => {
      this.applyInvocaMasking();
    }, 0);
  }

  setPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedCards();
      let el = document.getElementById("targetElement");
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedCards();
    }
  }


  toggleTooltip(card: any, event: MouseEvent) {
    this.mvpTip = false;
    this.mvspTip =true;
    event.stopPropagation();
    this.hideAllTooltips();
    card.showcardtooltip = !card.showcardtooltip;
    this.cdRef.detectChanges();
  }

  toggleTooltip2(card:any,event: MouseEvent){
    this.mvspTip = false;
    this.mvpTip = true;
    event.stopPropagation();
    this.hideAllTooltips();
    card.showcardtooltip = !card.showcardtooltip;
  }

  toggleTooltip3(card:any,event: MouseEvent){
    this.mvspTip = false;
    this.mvpTip = false;
    event.stopPropagation();
    this.hideAllTooltips();
    card.showcardtooltip = !card.showcardtooltip;
  }

  checkboxChange(event: any) {
    if (event.target.value == "applied rep") {
      this.appliedRepChecked = event.target.checked;
    } else if (event.target.value == "distributor") {
      this.distributorChecked = event.target.checked;
    }
    if (this.appliedRepChecked && this.distributorChecked) {
      this.professionalFilter = "";
    } else if (this.appliedRepChecked || this.distributorChecked) {
      this.professionalFilter = this.appliedRepChecked
        ? "Applied Rep"
        : "Distribution";
    } else {
      this.professionalFilter = "";
    }
  }

  isValidUSZip(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let zipCode = control.value;

      if (!zipCode) {
        return null;
      }

      zipCode = zipCode.toString();

      const zipPattern = /^\d{5}(-\d{4})?$/;

      if (!zipPattern.test(zipCode)) {
        return { invalidZipCode: true };
      }

      const firstFiveDigits = zipCode.includes("-")
        ? zipCode.split("-")[0]
        : zipCode;

      const zipNumber = parseInt(firstFiveDigits, 10);
      if (zipNumber < 1 || zipNumber > 99950) {
        return { invalidZipCode: true };
      }
      return null;
    };
  }

  formatPhoneNumber(value: string): string {
    let formatted = value.replace(/\D/g, "");
    if (formatted.length > 3) {
      formatted = `(${formatted.substring(0, 3)}) ${formatted.substring(3)}`;
    }
    if (formatted.length > 6) {
      formatted = `${formatted.substring(0, 9)}-${formatted.substring(9, 13)}`;
    }
    return formatted;
  }

  applyInvocaMasking() {
    if ((window as any)["Invoca"] && (window as any)["Invoca"].PNAPI) {
      // (window as any)["Invoca"].PNAPI.run({
      //   success: (data: any) => {
      //     console.log("Invoca API call successful:", data);
      //   },
      //   error: (error: any) => {
      //     console.error("Error initializing Invoca:", error);
      //   },
      // });
      setTimeout(() => {
        const phoneElements = document.querySelectorAll(".hidden-phone");
        for (let i = 0; i < phoneElements.length; i++) {
          const element = phoneElements[i];
          element.classList.remove("hidden-phone");
        }
        this.cdRef.detectChanges();
      }, 1500);
    } else {
      console.error("Invoca.PNAPI is not available.");
    }
  }

  getProfessionals() {
    this.captchaVerified = false;
    this.reCaptchaCallout();
    this.currentPage = 1;
    this.cards = [];
    this.paginatedCards = [];
    this.submitted = true;
    this.errorMessage = null;
    this.errorLink = null;
    this.noResultFound = null;
    if (this.searchForm.invalid) {
      return;
    } else {
      this.isLoading = true;
      try {
        this.professionalLocator
          .getLatAndLong(
            this.searchForm.value.searchField,
            this.professionalFilter
          )
          .subscribe(
            (res: any) => {
              if (res[0].errorMessage == null) {
                this.errorMessage = null;
                res.forEach((item: any) => {
                  let ModelAvailability =
                    item.Professional.strRestrictedModelAvailability;
                  if (ModelAvailability != null) {
                    this.tags = ModelAvailability.split(";");
                    item.tags = this.tags;
                  }
                  item.showcardtooltip = false;
                });
                this.cards = res;
                this.totalPages = Math.ceil(
                  this.cards.length / this.itemsPerPage
                );
                this.updatePaginatedCards();
                this.isLoading = false;
                setTimeout(() => {
                  this.applyInvocaMasking();
                }, 0);
                this.noResultFound = null;
                this.errorLink = null;
              } else {
                this.isLoading = false;
                this.noResultFound = `${res[0].errorMessage} Please visit:`;
                this.errorLink = "https://dealers.us.lg.com/";
              }
            },
            (error: any) => {
              if (error == "No geocode data found") {
                this.errorMessage = "Please enter a valid zip code";
              } else {
                this.errorMessage =
                  "Something went wrong,Please try again later";
              }
              this.noResultFound = null;
              this.errorLink = null;
              this.isLoading = false;
            }
          );
      } catch (error) {
        this.errorMessage = error;
        this.isLoading = false;
      }
    }
    this.reCaptchaVerification();
  }
  onCaptchaSuccess(response: string): void {
    
    this.captchaResponse = response;

    if (response) {
      this.zone.run(() => {
        this.captchaVerified = true;  // Enable the button
        setTimeout(() => {
          this.reCaptchaCallout();
        }, 30000);
      });;

    }
  
  }
  reCaptchaVerification(): void {
    const baseUrl = environment.baseUrl;

    if (this.captchaResponse) {
      const verifyApiUrl = `${baseUrl}professional/reCaptchaVerification`;

      const body = { token: this.captchaResponse }; // Send the token in the body
      this.http.post(verifyApiUrl, body).subscribe(
        (res: any) => {
          if (res.success) {
            console.log('Verification successful');
            // Handle success, e.g., enable form submission
          } else {
            console.error('Verification failed:', res['error-codes']);
            // Handle failure, e.g., show error message to the user
          }
        },
        (err) => {
          console.error('Error during verification:', err);
          // Handle network or server errors
        }
      );
    }
  }
  
  
  
  
  reCaptchaCallout(){
    grecaptcha.reset();
    this.zone.run(() => {
      this.captchaVerified = false;  // Enable the button
      grecaptcha.reset();
    });
  }
  loadreCaptchaScript(){
    const recaptchascript = this.renderer.createElement("script");
    recaptchascript.type = "text/javascript";
    recaptchascript.async = true;
    recaptchascript.defer =true;
    recaptchascript.src ="https://www.google.com/recaptcha/api.js";
      

    const head = document.getElementsByTagName("head")[0];
    this.renderer.appendChild(head, recaptchascript);
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/locator/locator.component.ts